import {AuthPayload} from '../../common/auth';
import {ACTION_TYPES} from "./types";
export default {
    login(payload: AuthPayload) {
        return {
            payload,
            type: ACTION_TYPES.LOGIN,
        }
    },
    register(payload: AuthPayload) {
        return {
            payload,
            type: ACTION_TYPES.REGISTER,
        }
    },
    logOut() {
        return {
            type: ACTION_TYPES.LOGOUT,
        }
    },
}
